var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VolumeTransaction'),_c('div',{staticClass:"row"},[_c('VolumeTransactionBySimType'),_c('CChartDoughnutExample')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }